import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useTaskGroupHeaderNames = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      overdue: t("Overdue"),
      started: t("Started"),
      tomorrow: t("Tomorrow"),
      today: t("Today"),
      restOfWeek: t("Rest of Week"),
      nextWeek: t("Next Week"),
      upcoming: t("Upcoming"),
      notSet: t("Not Set"),
    }),
    [t]
  );
};
